// @ts-check

import BaseModel from "@kaspernj/api-maker/build/base-model.js"

const modelClassData = {
  "attributes": {
    "id": {
      "column": {
        "default": null,
        "name": "id",
        "null": false,
        "type": "uuid"
      },
      "name": "id",
      "selected_by_default": null,
      "translated": null
    },
    "name": {
      "column": {
        "default": null,
        "name": "name",
        "null": false,
        "type": "string"
      },
      "name": "name",
      "selected_by_default": null,
      "translated": null
    },
    "primary_school_step": {
      "column": {
        "default": null,
        "name": "primary_school_step",
        "null": true,
        "type": "integer"
      },
      "name": "primary_school_step",
      "selected_by_default": null,
      "translated": null
    }
  },
  "className": "ClassStep",
  "collectionKey": "class_steps",
  "collectionName": "class_steps",
  "i18nKey": "class_step",
  "camelizedLower": "classStep",
  "name": "ClassStep",
  "nameDasherized": "class-step",
  "pluralName": "class_steps",
  "ransackable_associations": [
    {
      "className": "CompetitionClassStep",
      "collectionName": "competition_class_steps",
      "foreignKey": "class_step_id",
      "name": "competition_class_steps",
      "macro": "has_many",
      "resource_name": "CompetitionClassStep",
      "through": null
    },
    {
      "className": "Competition",
      "collectionName": "competitions",
      "foreignKey": "competition_id",
      "name": "competitions",
      "macro": "has_many",
      "resource_name": "Competition",
      "through": "competition_class_steps"
    },
    {
      "className": "HighscoreClassStep",
      "collectionName": "highscore_class_steps",
      "foreignKey": "class_step_id",
      "name": "highscore_class_steps",
      "macro": "has_many",
      "resource_name": "HighscoreClassStep",
      "through": null
    },
    {
      "className": "Highscore",
      "collectionName": "highscores",
      "foreignKey": "highscore_id",
      "name": "highscores",
      "macro": "has_many",
      "resource_name": "Highscore",
      "through": "highscore_class_steps"
    },
    {
      "className": "Log",
      "collectionName": "logs",
      "foreignKey": "trackable_id",
      "name": "logs",
      "macro": "has_many",
      "resource_name": "Log",
      "through": null
    },
    {
      "className": "Person",
      "collectionName": "people",
      "foreignKey": "class_step_id",
      "name": "people",
      "macro": "has_many",
      "resource_name": "Person",
      "through": null
    },
    {
      "className": "SchoolClass",
      "collectionName": "school_classes",
      "foreignKey": "class_step_id",
      "name": "school_classes",
      "macro": "has_many",
      "resource_name": "SchoolClass",
      "through": null
    },
    {
      "className": "SchoolYear",
      "collectionName": "school_years",
      "foreignKey": "class_step_id",
      "name": "school_years",
      "macro": "has_many",
      "resource_name": "SchoolYear",
      "through": null
    },
    {
      "className": "Tagging",
      "collectionName": "taggings",
      "foreignKey": "resource_id",
      "name": "taggings",
      "macro": "has_many",
      "resource_name": "Tagging",
      "through": null
    },
    {
      "className": "Tag",
      "collectionName": "tags",
      "foreignKey": "tag_id",
      "name": "tags",
      "macro": "has_many",
      "resource_name": "Tag",
      "through": "taggings"
    },
    {
      "className": "Tenant",
      "collectionName": "tenants",
      "foreignKey": "tenant_id",
      "name": "tenant",
      "macro": "belongs_to",
      "resource_name": "Tenant",
      "through": null
    },
    {
      "className": "WorkerPlugins::WorkplaceLink",
      "collectionName": "workplace_links",
      "foreignKey": "resource_id",
      "name": "workplace_links",
      "macro": "has_many",
      "resource_name": "WorkplaceLink",
      "through": null
    }
  ],
  "ransackable_attributes": [
    {
      "name": "created_at",
      "column": {
        "default": null,
        "name": "created_at",
        "null": false,
        "type": "datetime"
      }
    },
    {
      "name": "id",
      "column": {
        "default": null,
        "name": "id",
        "null": false,
        "type": "uuid"
      }
    },
    {
      "name": "id_string",
      "column": null
    },
    {
      "name": "name",
      "column": {
        "default": null,
        "name": "name",
        "null": false,
        "type": "string"
      }
    },
    {
      "name": "old_id",
      "column": {
        "default": null,
        "name": "old_id",
        "null": true,
        "type": "integer"
      }
    },
    {
      "name": "position",
      "column": {
        "default": 0,
        "name": "position",
        "null": false,
        "type": "integer"
      }
    },
    {
      "name": "primary_school_step",
      "column": {
        "default": null,
        "name": "primary_school_step",
        "null": true,
        "type": "integer"
      }
    },
    {
      "name": "tenant_id",
      "column": {
        "default": null,
        "name": "tenant_id",
        "null": false,
        "type": "uuid"
      }
    },
    {
      "name": "updated_at",
      "column": {
        "default": null,
        "name": "updated_at",
        "null": false,
        "type": "datetime"
      }
    }
  ],
  "ransackable_scopes": [
    {
      "name": "in_current_workplace"
    },
    {
      "name": "soft_deleted_filter"
    },
    {
      "name": "sort_by_in_current_workplace_asc"
    },
    {
      "name": "sort_by_in_current_workplace_desc"
    }
  ],
  "relationships": [],
  "paramKey": "class_step",
  "primaryKey": "id"
}

/** Frontend model for ClassStep. */
export default class ClassStep extends BaseModel {
  /** @returns {typeof modelClassData} */
  static modelClassData() {
    return modelClassData
  }

  /** @returns {string} */
  id() {
    return this.readAttributeUnderscore("id")
  }

  /** @returns {boolean} */
  hasId() {
    const value = this.id()

    return this._isPresent(value)
  }

  /** @returns {string} */
  name() {
    return this.readAttributeUnderscore("name")
  }

  /** @returns {boolean} */
  hasName() {
    const value = this.name()

    return this._isPresent(value)
  }

  /** @returns {number | null} */
  primarySchoolStep() {
    return this.readAttributeUnderscore("primary_school_step")
  }

  /** @returns {boolean} */
  hasPrimarySchoolStep() {
    const value = this.primarySchoolStep()

    return this._isPresent(value)
  }
}
